/**
 * Reference Materials API Client
 *
 * Client for accessing reference materials (guidance and process maps) for compliance users
 */

import { ApiClient } from '@core/apiClient';

export interface ReferenceMaterial {
  id: number;
  title: string;
  description: string;
  type: 'guidance' | 'process_map';
  category: string;
  content?: string;
  diagramData?: string;
  frameworkName?: string;
  lastUpdated: string;
}

export class ReferenceMaterialsApi extends ApiClient {
  constructor() {
    super({
      enableLogging: import.meta.env.DEV,
    });
  }

  /**
   * Get all reference materials (guidance and process maps)
   */
  async getReferenceMaterials(): Promise<ReferenceMaterial[]> {
    const response = await this.client.get('/compliance/reference-materials');
    return response.data.data;
  }
}

export const referenceMaterialsApi = new ReferenceMaterialsApi();